import { render } from "./AppMain.vue?vue&type=template&id=f75b485e&scoped=true&lang=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=f75b485e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f75b485e"

export default script